export default "__VITE_ASSET__a6acc4c3__"